<template>
  <div>
    <!-- 系统列表 -->
    <a-table id="myServiceTable" :columns="columns" :data-source="tableData"  :scroll="{ x: clientWidth}" :pagination="false"  :loading="tloading" rowKey="id"
    bordered size="middle" @change="handleTableChange">
        <template slot="rateText" slot-scope="text">
            <span >{{text + '%'}}</span>
        </template>

        <template slot="opration_detail" slot-scope="text,record">
            <a-button type="link" @click="handleRecordDetail(record,1)">详细</a-button>
        </template>

        <template slot="opration_logs" slot-scope="text,record">
            <a-button type="link" @click="handleRecordDetail(record,2)">日志</a-button>

        </template>


        <template slot="opration_folow" slot-scope="text,record">
            <a-button type="link" v-if="checkFolow(record)" @click="handleRecordFolow(record)">关注</a-button>
            <a-button type="link" v-else @click="handleDeleteFolow(record)">取消关注</a-button>
        </template>

        <template slot="linkUrl" slot-scope="text,record">
            <a href="javascript:void(0)" @click="handleRecordUrl(record)"> {{text}}</a>
        </template>
        

    </a-table>

    <a-pagination  style="float:right;margin-top:20px;" v-model="pagenation.current" :pageSize="pagenation.pageSize" :total="pagenation.total" @change="handlePageChange" show-less-items show-quick-jumper />


    <a-modal v-model="visible" title="您还没有添加关注服务" ok-text="立即前往" cancel-text="取消" @ok="hideModal">
      <p>是否前往“应用统计”添加关注 ?</p>
    </a-modal>
  </div>
</template>
<script>
let pagenation ={
    current:1,
    pageSize:10,
    total:0
};

const columns1 = [
    {
        title: "序号",
        width: 50,
        align: "center",
        customRender: (text, record, index) => {
            let { current, pageSize } = pagenation;
            return (Number(current) - 1) * Number(pageSize) + index + 1;
        }
    },
];
const columns_extra = [
    {
        title: "serverName",
        dataIndex: "serverName",
        width:250,
        align: "center",
    },
    {
        title: "topic",
        dataIndex: "topic",
        width:80,
        align: "center",
    }
]
const columns2 = [
    {
        title: "系统编码",
        dataIndex: "AppCode",
        width:80,
        align: "center",

    },
    {
        title: "调用方系统编码",
        dataIndex: "invokeappcode",
        width:120,
        align: "center",

    },
    {
        title: "URL",
        dataIndex: "url",
        scopedSlots: { customRender: 'linkUrl' },
        width:500,
        align: "left",
        ellipsis: true
    },
    {
        title: "调用方式",
        dataIndex: "Type",
        width:80,
        align: "center",
    }]
const columns3 = [
    {
        title: "详细",
        dataIndex: "详细",
        width:60,
        align: "center",
        scopedSlots: { customRender: 'opration_detail' },
        ellipsis: true
    }];
const columns4 = [
    {
        title: "日志",
        dataIndex: "日志",
        width:60,
        align: "center",
        scopedSlots: { customRender: 'opration_logs' },
        ellipsis: true
    },
    {
        title: "关注",
        dataIndex: "关注",
        width:80,
        align: "center",
        scopedSlots: { customRender: 'opration_folow' },
        ellipsis: true
    },
    {
        title:"消费方指标",
        children:[
            {
                title: "调用次数",
                dataIndex: "Total",
                width:90,
                sorter: true,
                defaultSortOrder :'descend',
                align: "center",
            },
            {
                title: '调用成功',
                children:[
                    {
                        title: '成功次数',
                        dataIndex: 'SuccessNumber',
                        align: 'center',
                        width: 90,
                        sorter: true,
                    },
    
                    {
                        title: '成功比例',
                        dataIndex: 'SuccessRate',
                        align: 'center',
                        scopedSlots: { customRender: 'rateText' },
                        width: 90,
                    },
   
                ]
            },
            {
                title: '调用失败',
                children:[
                    {
                        title: '失败次数',
                        dataIndex: 'FailNumber',
                        align: 'center',
                        width: 90,
                        sorter: true,
                    },
                    {
                        title: '失败比例',
                        dataIndex: 'failRate',
                        align: 'center',
                        width: 90,
                        scopedSlots: { customRender: 'rateText' },
                    },
                ]
            },{
                title: '调用耗时 ms',
                children:[
                    
                    {
                        title: '平均耗时',
                        dataIndex: 'avghandtime',
                        align: 'center',
                        width: 90,
                        sorter: true,
                    },
                    {
                        title: 'TP90',
                        dataIndex: 'TP90',
                        align: 'center',
                        width: 90,
                        sorter: true,
                    },
                    {
                        title: 'TP99',
                        dataIndex: 'TP99',
                        align: 'center',
                        width: 90,
                        sorter: true,
                    },
                    {
                        title: 'TP999',
                        dataIndex: 'TP999',
                        align: 'center',
                        width: 90,
                        sorter: true,
                    }
                ]
            },
        ]
    },
    
   
   

];


export default {
    data() {
        return {
            columns:[],
            tableData:[],
            tloading:false,
            pagenation,
            oldPageNum:1,
            myFolowsData:[],
            clientWidth:800,
            visible:false,
            orderStr:'order by Total desc',
        };
    },
    methods: {
        handleTableChange(d,v,sorter) {
            if(sorter.order){
                this.orderStr = ' order by ' + sorter.field + ' ' + sorter.order.replace('end','');
            }
            else{
                this.orderStr = '';
            }
            console.log(this.orderStr)

            this.getAppSumData();
        },
        handlePageChange(v){
            this.pagenation.current = v
            this.getAppSumData();
        },
        updateMyFlow(doLoad,forceUpdate){
            let that = this;
            //缓存
            let localFlowData = localStorage.getItem("monitorserviceFlowService");
            if(forceUpdate || !localFlowData){
                let params = {
                    folowtype:'service',
                    urlparams:false
                };
                that.$store.dispatch({
                    type: "logservice/queryfolow",
                    params:params
                }).then((res)=>{
                    if(res.status == 200 && res.data.success == 1){
                        let array = res.data.data;
                        that.myFolowsData = array;
                        localStorage.setItem("monitorserviceFlowService",JSON.stringify(array))
                        if(doLoad){
                            that.getAppSumData();
                        }
                    }
                    else{
                        that.message.error("调用接口失败")
                        localStorage.setItem("monitorserviceFlowService","")
                    }

                }).catch(() => {
                    localStorage.setItem("monitorserviceFlowService","")
                });
            }
            else{
                that.myFolowsData = JSON.parse(localFlowData);
                if(doLoad){
                    that.getAppSumData();
                }
            }
            
           
        },
        checkFolow(record){
            let result = this.getFolowData(record);
            return result.length == 0
        },
        getFolowData(record){
            return this.myFolowsData.filter((n)=>{return n.servicekey == record.url && n.appcode == record.AppCode && n.invokeappcode == record.invokeappcode})
        },
        showConfirm() {
            this.visible = true;
        },
        hideModal(){
            this.visible = false;
            this.$router.push({
                path: '/monitorservice/appsum'
            })
        },
        getAppSumData(){
            let whereStr = "";
            let searchAppcode = this.searchD.selectedAppcode;
            let searchType = this.searchD.selectedType;
            let severNameKeyWord = this.searchD.severNameKeyWord;
            let topicKeyWord = this.searchD.topicKeyWord;
            let searchInvokAppcode = this.searchD.selectedInvokeappcode;
            let servicekey = this.searchD.servicekey;
            let clientip = this.searchD.clientip;
            this.getColoms(searchType);
            if(this.onlyFlow == 2){
                //我的关注表格
                whereStr = "";
                if(this.myFolowsData.length > 0){
                    whereStr = " where "
                    for (let index = 0; index < this.myFolowsData.length; index++) {
                        const element = this.myFolowsData[index];
                        if(index == 0){
                            whereStr += " (AppCode = '" + element.appcode + "' and invokeappcode = '" + element.invokeappcode + "' and url = '" + element.servicekey +"') ";
                        }
                        else{
                            whereStr += " or (AppCode = '" + element.appcode + "' and invokeappcode = '" + element.invokeappcode + "' and url = '" + element.servicekey +"') ";
                        }
                    }
                }
                else{
                    this.showConfirm()
                    return;
                }
                
            }
            else if(this.onlyFlow == 1){
                //应用统计表格
                whereStr = " where 1=1 ";
                if(searchAppcode){
                    whereStr += "and AppCode = '" + searchAppcode + "'";
                }
                if(searchType){
                    whereStr += "and bptype = '" + searchType + "'";
                }
                if(servicekey){
                    whereStr += "and url = '" + servicekey + "'";
                }

                if(searchType && severNameKeyWord){
                    whereStr += "and requestparams like '%" + severNameKeyWord + "%'";
                }

                if(searchType && topicKeyWord){
                    whereStr += "and requestparams like '%" + topicKeyWord + "%'";
                }


                if(searchInvokAppcode){
                    whereStr += "and invokeappcode = '" + searchInvokAppcode + "'";
                }
            }else if(this.onlyFlow == 3){
                //服务统计表格
                whereStr = " where 1=1 ";
                if(searchAppcode){
                    whereStr += "and AppCode = '" + searchAppcode + "'";
                }
                if(searchInvokAppcode){
                    whereStr += "and invokeappcode = '" + searchInvokAppcode + "'";
                }
                if(servicekey){
                    whereStr += "and url = '" + servicekey + "'";
                }
                if(clientip){
                    whereStr += "and clientip = '" + clientip + "'";
                }
            }

            let isMq = (searchType == 'mq' && this.onlyFlow == 1);
            let extra_coloms = isMq ? ("regexp_extract(requestparams,'serviceName>(\\w+)',1) as serverName ," +
                "regexp_extract(requestparams,'topic>(\\w+)',1) as topic,") : '';
            let extra_where = isMq ? ",serverName,topic " : "";


            let queryStr = "* | select appCode as AppCode,"+
                " invokeappcode as invokeappcode," +
                "url as url,bptype AS Type, " +
                "count(1) as Total," +
                extra_coloms +
                "count_if(success='true') as SuccessNumber," +
                "count_if(success='false') as FailNumber," +
                "round(count_if(success='true')*100.000/count(1),3)  as SuccessRate, " +
                "round(count_if(success='false')*100.000/count(1),3)  as failRate, " +
                "concat(cast(round(approx_percentile(handtime,0.9),1) AS varchar),'ms') as TP90," +
                "concat(cast(round(approx_percentile(handtime,0.99),1) AS varchar),'ms') as TP99," +
                "concat(cast(round(avg(handtime),1) AS varchar),'ms') as avghandtime," +
                "round(approx_percentile(handtime,0.999),1) as TP999 " + 
                "from log " + 
                whereStr +
                " group by AppCode, URL,Type,invokeappcode " + extra_where + this.orderStr;

            let that = this;
            that.tloading = true;
            let starttime = (new Date(that.searchD.searchTimeRange.split('~')[0]).getTime())/1000;
            let endtime = (new Date(that.searchD.searchTimeRange.split('~')[1]).getTime())/1000;
            let params = {
                projectname: that.G.getServiceMonitorName(),
                logstorename:'service-monitor',
                starttime:starttime,
                endtime:endtime,
                sql:queryStr,
                pageSize:that.pagenation.pageSize,
                offset:(that.pagenation.current - 1) * that.pagenation.pageSize,
                reverse:false,
                paged:true,
                timeout:15000,
                urlparams:false
            };
            that.$store.dispatch({
                type: "logservice/querylog",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    result.list.forEach(element => {
                        element.id = that.G.generateUUID()
                    });
                    that.tableData = result.list;
                    that.pagenation.total = parseInt(result.count);
                }
                that.tloading = false;
            }).catch(() => {
                that.tloading = false;

            });
        },

        getColoms(searchType){
            let resultColoms = [];
            if(searchType == 'mq' && this.onlyFlow == 1){
                resultColoms = resultColoms.concat(columns1)
                resultColoms = resultColoms.concat(columns_extra)
            }
            else{
                resultColoms = resultColoms.concat(columns1)
            }
            if(this.onlyFlow == 3){
                //去除详情字段
                resultColoms =  resultColoms.concat(columns2)
                resultColoms =  resultColoms.concat(columns4)
            }
            else{
                resultColoms = resultColoms.concat(columns2)
                resultColoms =  resultColoms.concat(columns3)
                resultColoms = resultColoms.concat(columns4)
            }
            this.columns = resultColoms;
        },
   
        handleRecordDetail(record,flag){
            const {url} = record;
            let monitorDetail = {
                servicekey:url,
                selectedAppcode :record.AppCode,
                selectedType:record.Type,
                selectedInvokeappcode :record.invokeappcode,
                searchTimeRange:this.searchD.searchTimeRange,
                timeType:this.searchD.timeType,
                clientip:this.searchD.clientip
            }
            localStorage.setItem("monitorserviceDetailSearch",JSON.stringify(monitorDetail));
            let tPath = flag == 1 ? "/monitorservice/servicesum" :  "/monitorservice/log";
            this.$router.push({
                path: tPath,
                query:{
                    searchTimeRange:this.searchD.searchTimeRange,
                    dateTypeTitle:this.searchD.timeType
                }
            });
        },
        //添加关注服务
        handleRecordFolow(record){
            //更新列表
            //调用接口添加关注系统
            let that = this;
            let params = {
                appcode:record.AppCode,
                folowtype:'service',
                invokeappcode:record.invokeappcode,
                servicekey:record.url,
                urlparams:false
            };
            that.$store.dispatch({
                type: "logservice/addfolow",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == 1){
                    that.updateMyFlow(false,true)
                }

            }).catch(() => {
            });
        },
        handleRecordUrl(record){
            this.$emit('handleUrlSelected',record.url);
        },
        handleDeleteFolow(record){
            let targetFollow = this.getFolowData(record);
            if(targetFollow.length > 0){
                let c_id = targetFollow[0].id
                let that = this;
                let params = {
                    id:c_id,
                   
                    urlparams:false
                };
                that.$store.dispatch({
                    type: "logservice/deletefolow",
                    params:params
                }).then((res)=>{
                    if(res.status == 200 && res.data.success == 1){
                        this.updateMyFlow(false,true);
                    }

                }).catch(() => {
                });
            }
            else{
                this.message.error("未知错误")
            }
        }
    },
    props:{
        searchD:{
            selectedAppcode:String,
            selectedType:String,
            selectedInvokeappcode:String,
            servicekey:String,
            searchTimeRange:String,
            timeType:String,
        },
        onlyFlow:Number,

    },
    watch:{
        'searchD'(newVal){
            if(newVal){
                this.pagenation.current = 1;
                this.updateMyFlow(true,false);
            }
        }
    },
    components:{
    },
    mounted(){
    }
};
</script>
<style scoped>
    .trend_pagenation{
        margin-top: 10px;
    }


</style>

